// extracted by mini-css-extract-plugin
module.exports = {"infoRootContainer":"Info_infoRootContainer__Z5MQi","imageContainer":"Info_imageContainer__1ArfK","right":"Info_right__2gjPp","rightInner":"Info_rightInner__3DIVQ"};